import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfensorFormatado, OfensorProdutividade } from 'app/interfaces/OfensorProdutividade';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-ofensores-produtividade',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './ofensores-produtividade.component.html',
  styleUrl: './ofensores-produtividade.component.css'
})
export class OfensoresProdutividadeComponent {
  @Input() ofensoresProdutividade: OfensorProdutividade = {};
  protected readonly Math = Math;

  get ofensoresFormatados(): OfensorFormatado[] {
    return Object.entries(this.ofensoresProdutividade)
      .map(([nome, porcentagem], index) => ({
        nome,
        porcentagem,
        classe: `top-${index + 1}`
      }))
      .sort((a, b) => b.porcentagem - a.porcentagem)
      .slice(0, 5);
  }
}
